import TituloNegrito from './TituloNegrito';
import CardOutraCertificacao from './CardOutraCertificacao';

import { retornarTexto } from '../helpers/textoHelper'

function SelosConsumoConsciente({ selos, resolucaoMobile, idioma }) {

    if (!selos || selos.length === 0) return <></>

    // Busca a coluna do idioma selecionado e, se ela estiver vazia, usa a coluna em português
    function retornarCampo(selo, nomeCampo) {
        if (idioma === 'en') {
            return selo[`${nomeCampo} (Inglês)`] ? selo[`${nomeCampo} (Inglês)`] : selo[nomeCampo]
        } else if (idioma === 'es') {
            return selo[`${nomeCampo} (Espanhol)`] ? selo[`${nomeCampo} (Espanhol)`] : selo[nomeCampo]
        } else if (idioma === 'fr') {
            return selo[`${nomeCampo} (Francês)`] ? selo[`${nomeCampo} (Francês)`] : selo[nomeCampo]
        } else {
            return selo[nomeCampo]
        }
    }

    return (
        <div className='animate__animated animate__fadeIn d-flex flex-column align-items-center justify-content-center' style={{ gap: '20px' }}>
            <TituloNegrito texto={retornarTexto(idioma, 'selos')} />
            <div className='mb-5 animate__animated animate__fadeIn d-flex flex-wrap align-items-center justify-content-center' style={{ gap: '30px' }}>
                {selos.map((selo) => <CardOutraCertificacao
                    key={selo['Nome do selo']}
                    nome={retornarCampo(selo, 'Nome do selo')}
                    urlImagem={retornarCampo(selo, 'Link da imagem do selo')}
                    link={retornarCampo(selo, 'Link do selo')}
                    resolucaoMobile={resolucaoMobile} />)}
            </div>
        </div>
    );
}
export default SelosConsumoConsciente;
